import { useFragment } from '@apollo/client';
import type { AccountManagedByAdobeFragment } from '@frameio/graphql-client/generated';
import { AccountManagedByAdobe } from '@frameio/graphql-client/generated';
import { isAccountAdobeManaged } from '@frameio/graphql-client/utils/isAccountAdobeManaged';
import { useActiveAccountId } from '@frameio/shared/contexts';

/**
 * This hook checks if the user is on an account managed by Adobe (an Adobe
 * enterprise organization or a Creative Cloud Individual subscription).
 */
export function useManagedByAdobe() {
  const accountId = useActiveAccountId() ?? '';
  const { complete, data } = useFragment<AccountManagedByAdobeFragment>({
    fragment: AccountManagedByAdobe,
    fragmentName: 'AccountManagedByAdobe',
    from: {
      __typename: 'Account',
      id: accountId,
    },
  });

  const managedByAdobe = isAccountAdobeManaged(data?.managedBy);

  return complete ? managedByAdobe : false;
}
